import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const PSPSettingService = createApi({
  reducerPath: "PSPSettingService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getPSPSetting: builder.query<any, void>({
      query: (params) => ({
        url: `/setting-psp`,
        method: "GET",
        headers: {
          PageName: "PSP Setting",
        },
      }),
    }),
    getPSPSettingPagination: builder.query<any, any>({
      query: (params) => ({
        url: `/setting-psp`,
        method: "GET",
        headers: {
          PageName: "PSP Setting",
        },
        params
      }),
    }),
    getPSPSettingDetail: builder.query<any, {id: number}>({
        query: (params) => ({
          url: `/setting-psp/${params.id}`,
          method: "GET",
          headers: {
            PageName: "PSP Setting",
          },
        }),
    }),
    createPSPSetting: builder.mutation<any, any>({
        query: (params) => ({
          url: `/setting-psp`,
          body: params,
          method: "POST",
          headers: {
            PageName: "PSP Setting",
          },
        }),
    }),
    updatePSPSetting: builder.mutation<any, { id: number }>({
        query: (params) => ({
          url: `/setting-psp/${params?.id}`,
          body: params,
          method: "PUT",
          headers: {
            PageName: "PSP Setting",
          },
        }),
    }),
    deletePSPSetting: builder.mutation<any, {id: number }>({
        query: (params) => ({
          url: `/setting-psp/${params?.id}`,
          params,
          method: "DELETE",
          headers: {
            PageName: "PSP Setting",
          },
        }),
      }),
  }),
});

export const {
    useGetPSPSettingQuery,
    useGetPSPSettingPaginationQuery,
    useLazyGetPSPSettingDetailQuery,
    useCreatePSPSettingMutation,
    useUpdatePSPSettingMutation,
    useDeletePSPSettingMutation
  } = PSPSettingService;
  